import {
  XCircleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/solid';
import { twMerge } from 'tailwind-merge';

interface IProps {
  title: string;
  description?: string;
  type: 'info' | 'warning' | 'error' | 'success';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function Alert({
  title,
  description,
  type = 'info',
  className,
  size = 'md',
}: IProps) {
  return (
    <div
      className={twMerge([
        'w-full rounded-md p-4',
        size === 'sm' && 'p-2',
        size === 'md' && 'p-4',
        size === 'lg' && 'p-6',
        type === 'info' && 'bg-blue-50',
        type === 'warning' && 'bg-yellow-50',
        type === 'error' && 'bg-red-50',
        type === 'success' && 'bg-green-50',
        className,
      ])}
    >
      <div className="flex items-center">
        <div className="shrink-0">
          {type === 'error' && (
            <XCircleIcon aria-hidden="true" className="size-5 text-red-400" />
          )}
          {type === 'success' && (
            <CheckCircleIcon
              aria-hidden="true"
              className="size-5 text-green-400"
            />
          )}
          {type === 'info' && (
            <InformationCircleIcon
              aria-hidden="true"
              className="size-5 text-blue-400"
            />
          )}
          {type === 'warning' && (
            <ExclamationTriangleIcon
              aria-hidden="true"
              className="size-5 text-yellow-400"
            />
          )}
        </div>
        <div
          className={twMerge([
            size === 'sm' && 'ml-1 text-xs',
            size === 'md' && 'ml-2 text-sm',
            size === 'lg' && 'ml-3 text-base',
          ])}
        >
          <h3
            className={twMerge([
              'font-medium',
              type === 'info' && 'text-blue-800',
              type === 'warning' && 'text-yellow-800',
              type === 'error' && 'text-red-800',
              type === 'success' && 'text-green-800',
            ])}
          >
            {title}
          </h3>
          {description && (
            <div
              className={twMerge([
                'mt-2 text-yellow-700',
                type === 'info' && 'text-blue-700',
                type === 'warning' && 'text-yellow-700',
                type === 'error' && 'text-red-700',
                type === 'success' && 'text-green-700',
              ])}
            >
              <p>{description}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
